import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ArrowRightIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ArrowRightIcon = ({ className, ...props }: ArrowRightIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 12H18.5M18.5 12L12.5 6M18.5 12L12.5 18"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default ArrowRightIcon;
